import actionTypes from './actiontypes';
import config from '../../../config/config';
import { checkJapanese } from '../../../lib';

const {
  REQUEST_USER_LIST,
  RECEIVE_USER_LIST,
  SERVER_ERROR_OCURED,
  REQUEST_USER_LIST_DETAILS,
  RECEIVE_USER_LIST_DETAILS,
  CLEAR_ERRORS
} = actionTypes;

function hasErrored(errors) {
  return {
    type: SERVER_ERROR_OCURED,
    errors: errors
  };
}



export function fetchUserList(token,id) {
  return function(dispatch) {
    dispatch({ type: REQUEST_USER_LIST });
    return fetch(`${config.URI}/api/v1/fvdomains/${id}`, {
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      }
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText);
        } else {
          return res.json();
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          dispatch({ type: RECEIVE_USER_LIST, users: res.data.users, domain:res.data.domain });
        } else if (res.errors) {
          console.error(res.errors);
        }
      })
      .catch((error) => {
        dispatch(hasErrored(true))
        
        console.error(error)
      });
  };
}

export function addUser(token, payload) {
  return function(dispatch) {
    dispatch({ type: REQUEST_USER_LIST_DETAILS });
   
    return fetch(`${config.URI}/api/v1/fvdomain/user`, {
      method: 'POST',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json;charset=UTF-8'
      },
      body: JSON.stringify(payload)
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText);
        } else {
          return res.json();
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          dispatch(fetchUserList(token, payload.fvdomain_id));
          dispatch({type: "USER_SUCCESS", msg: 'User Created Successfully'})
        } else if (res.errors) {
          dispatch(hasErrored(res.errors))
          console.error(res.errors);
        }
      })
      .catch((error) => {
        dispatch(hasErrored(error))
        console.error(error)
      });
  };
}

export function editUser(token, payload, id) {
  return function(dispatch) {
    dispatch({ type: REQUEST_USER_LIST_DETAILS });
  
    return fetch(`${config.URI}/api/v1/fvdomain/user/${id}`, {
      method: 'PUT',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json;charset=UTF-8'
      },
      body: JSON.stringify(payload)
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText);
        } else {
          return res.json();
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
           dispatch(fetchUserList(token, payload.fvdomain_id));
           dispatch({type: "USER_SUCCESS", msg: 'User Updated Successfully'})
        } else if (res.errors) {
          dispatch(hasErrored(res.errors))
        }
      })
      .catch((error) => {
        dispatch(hasErrored(error))
        
        console.error(error)
      });
  };
}


export function genApiTokenUser(token, id, fvdomain_id) {
  return function(dispatch) {
    dispatch({ type: REQUEST_USER_LIST_DETAILS });
  
    return fetch(`${config.URI}/api/v1/fvdomain/user/genapitoken/${id}`, {
      method: 'POST',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json;charset=UTF-8'
      }
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText);
        } else {
          return res.json();
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
           dispatch(fetchUserList(token, fvdomain_id));
           dispatch({type: "USER_SUCCESS", msg: 'Api Token generated Successfully'})
        } else if (res.errors) {
          dispatch(hasErrored(res.errors))
        }
      })
      .catch((error) => {
        dispatch(hasErrored(error))
        
        console.error(error)
      });
  };
}

export function revokeApiTokenUser(token, id, fvdomain_id) {
  return function(dispatch) {
    dispatch({ type: REQUEST_USER_LIST_DETAILS });
  
    return fetch(`${config.URI}/api/v1/fvdomain/user/revokeapitoken/${id}`, {
      method: 'POST',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json;charset=UTF-8'
      }
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText);
        } else {
          return res.json();
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
           dispatch(fetchUserList(token, fvdomain_id));
           dispatch({type: "USER_SUCCESS", msg: 'Api Token Revoked Successfully'})
        } else if (res.errors) {
          dispatch(hasErrored(res.errors))
        }
      })
      .catch((error) => {
        dispatch(hasErrored(error))
        
        console.error(error)
      });
  };
}

export function deleteUser(token, id, fvdomain_id) {
  return function(dispatch) {
    dispatch({ type: REQUEST_USER_LIST_DETAILS });
    return fetch(`${config.URI}/api/v1/fvdomain/user/${id}`, {
      method: 'DELETE',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json;charset=UTF-8'
      }
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText);
        } else {
          return res.json();
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          dispatch(fetchUserList(token, fvdomain_id));
        } else if (res.errors) {
          alert(checkJapanese() ? 'ドメイン所有者は他のユーザーを全て削除するまで、自身を削除できません' : 'Domain owners cannot delete themselves until all other users have been deleted');
          console.error(res.errors);
        }
      })
      .catch((error) => {
        dispatch(hasErrored(true))
        
        console.error(error)
      });
  };
}

export function clearErrors() {
  return function(dispatch) { 
    dispatch({ type: CLEAR_ERRORS });
  }
 
}




// WEBPACK FOOTER //
// src/routes/Users/actions/index.js